import React from 'react'
import { Dropdown as DropdownComponent } from '@cse/ui'

import { DropdownProps } from './dropdown.types'
import { useStyle } from './dropdown.styles'
import { Row } from '../row'

export const Dropdown = ({
  fixed,
  className = '',
  ...props
}: DropdownProps) => {
  const classes = useStyle({ fixed })
  return (
    <Row className={`${className} ${classes.container}`}>
      <DropdownComponent {...props} />
    </Row>
  )
}
